<template>
  <flow-transition-card
    :flow-id="flowId"
    :item="item"
    :origin="stateName"
    :ingress="computedIsDestination"
    :dismiss="dismiss"
  />
</template>

<script>
import { mapState } from 'vuex'
import { Modal } from '@argon/app/mixins'
import { NAMESPACE } from '../store'
import { FlowTransitionCard } from '../components'

export default {
  name: 'flow-transition-modal',
  mixins: [Modal],
  components: {
    FlowTransitionCard
  },
  props: {
    flowId: {
      type: [String, Number],
      required: true
    },
    stateName: { type: String, required: true },
    transitionName: { type: String, required: true },
    ingress: [Boolean, String]
  },
  data() {
    return {
      returnPath: { name: 'flowState' }
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['current']),
    computedIsDestination() {
      return this.ingress === true || this.ingress === 'true'
    },
    item() {
      return this.current.meta.transitions.find((transition) => transition.name === this.transitionName)
    }
  }
}
</script>
